<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat>
          <v-toolbar-title>Payment Mode</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text to="/payment-modes">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- editor -->
            <editor :initial="dataItem" @data="save"></editor>
          <!-- end -->
        </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
import Editor from '../_components/editor.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    Editor
  },
  computed: {
    ...mapGetters(['user'])
  },
  data: () => ({
    dataItem: {}
  }),
  watch: {
      "$route.params.id": {
          handler: "getData",
          immediate: true
      }
  },
  methods: {
      getData(id) {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/payment-modes/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.dataItem = res.ResponseData;
            self.loading = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
      save(data) {
        const url = `/payment-modes/${data.id}`;
      const self = this;
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if(res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/payment-modes");
          }
        })
        .catch(() => {
          self.$store.commit("btnLoader", false);
          // this.$refs.snackbar.show(err, "red");
        });
    }
  }
};
</script>